import { render } from "./SimpleHeaderComponent.vue?vue&type=template&id=df7457b0&scoped=true"
import script from "./SimpleHeaderComponent.vue?vue&type=script&lang=js"
export * from "./SimpleHeaderComponent.vue?vue&type=script&lang=js"

import "./SimpleHeaderComponent.vue?vue&type=style&index=0&id=df7457b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7457b0"]])

export default __exports__